import React from 'react';
import { Link } from 'react-router-dom';
import './styles/Header.css'; // Create and style as needed

function Header() {
  return (
    <header className="header">
      <div className="logo">
        <Link to="/">KS TRADE INC.</Link>
      </div>
      <nav>
        <ul>
          <li><Link to="/">Home</Link></li>
          {/* <li><Link to="/title-loan">자동차 담보 대출</Link></li> */}
          <li><Link to="/inventory">Inventory</Link></li>
          <li><Link to="/apply-financing">Financing</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          {/* Add more links as needed */}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
